import type { LexicalEditor, SerializedEditorState } from "lexical";
import toast from "react-hot-toast";
import type { Json } from "../../../__definitions__/database-definitions";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import type { UUID } from "../../../utils/uuid";
import { useClaims } from "../../generic/hooks/use-claims";

export function useHandleFollowUpLexicalError(
  id: UUID,
): (e: Error, editor: LexicalEditor, undoStack: SerializedEditorState[]) => Promise<void> {
  const claims = useClaims();

  const writeUndoStack = useSupabaseCallback(
    async ({ supabase }, e: Error, editor: LexicalEditor, undoStack: SerializedEditorState[]) => {
      console.error(e);
      toast.error(`Editor Error ${e.message}, please contact support.`);
      await supabase.rpc("log_corrupt_lexical_state", {
        identifier: { type: "follow_up", id, claims: claims ?? null },
        stack: {
          content: editor.getEditorState().toJSON() as unknown as Json,
          stack: undoStack as unknown as Json,
        },
      });
    },
    [id, claims],
  );

  return writeUndoStack;
}
